import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

/*
  Shared fixed-position back button (bottom-left, mirroring the hamburger).
  One component instead of the same inline SVG pasted into every page.
*/
function BackButton() {
  const navigate = useNavigate();
  return (
    <button className="back-btn" onClick={() => navigate(-1)} aria-label="Go back">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18l-6-6 6-6" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}

export default BackButton;
